import { ONE, THREE, ZERO } from '@/constants';
import { useGrowthPlans } from '@/hooks';
import { Paper, Typography } from '@/ui';

import GrowthPlanCardDescription from './GrowthPlanCardDescription';

import BoulderImage from '@/components/Growth/BoulderImage';

const GrowthPlanCard = () => {
  const { plans, isPlansLoading } = useGrowthPlans();

  if (isPlansLoading || !plans.length || !plans[0]?.id) {
    return null;
  }

  const plan = plans[0];

  if (!plan.started) {
    return (
      <>
        <Typography className="pb-2" variant="h4">
          Build your personal growth plan
        </Typography>
        <Typography variant="body2">
          Partner with your Mento Coach to create a tailored career growth plan.
        </Typography>
      </>
    );
  }

  if (plan.milestones.length === ZERO) {
    return (
      <>
        <Typography className="pb-2" variant="h4">
          No milestones in the works
        </Typography>
        <Typography variant="body2">
          You don’t have any active milestones in your Growth Plan. What’s next
          on your horizon?
        </Typography>
      </>
    );
  }

  // started and has milestones
  return (
    <>
      <Typography className="pb-2" variant="h4">
        {plan.milestones.length}{' '}
        {plan.milestones.length > ONE ? 'milestones' : 'milestone'}
      </Typography>

      {plan.milestones.slice(ZERO, THREE).map((milestone) => (
        <Paper
          key={milestone.id}
          className="my-1.5 border-2 border-solid border-sage-300 p-2"
          elevation={0}
        >
          <div className="flex">
            <div className="my-auto mr-5 h-8 shrink-0">
              <BoulderImage milestone={milestone} />
            </div>
            <div>
              <Typography className="mb-0.5" variant="subtitle2">
                {milestone.title}
              </Typography>
              <GrowthPlanCardDescription milestone={milestone} />
            </div>
          </div>
        </Paper>
      ))}
    </>
  );
};

export default GrowthPlanCard;
